<template>
    <div class="mobile-nav-main">
        <ul class="list-unstyled nav">
            <li v-for="(item, index) in setup.main_page_navigation_mobile" class="parent-link" :data-href="item.href" :key="index" :class="{open : currentIndex == index, 'sales-link' : item.href == '/sales'}">
                <a href="#" @click.prevent="setCurrentIndex(index, item.href)">
                    <span>{{item.name}}</span>
                    <div class="nav-icon" v-if="item.dropdown != false">
                        <svgIcon name="arrow_drop" class="icon-arrow-down"/>
                    </div>
                </a>
                <slide-up-down :active="currentIndex == index" :duration="400" v-if="item.dropdown != false" class="dropdown-menu-mobile">
                    <ul>
                        <li v-for="link in item.dropdown">
                            <router-link :to="link.link" @click.native="startLoader">{{link.name}}</router-link>
                        </li>
                    </ul>
                </slide-up-down>
            </li>
        </ul>
    </div>
</template>

<script>
    import SlideUpDown from 'vue-slide-up-down'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    import {mapGetters} from 'vuex'
    export default {
        name: 'mobile-nav-main',
        data () {
            return {
                currentIndex: 0,
                regionCity: null,
            }
        },
        components: {
            SlideUpDown,
            svgIcon,
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
            currentCityArr: 'loadCurrentCityArr',
        }),
        methods: {
            setCurrentIndex(index, link) {
                console.log(link)
                if (link != '/about' && link != '/projects' && link != '/activites') {
                    this.$router.push(link);
                    this.$parent.$parent.$refs.topProgress.start();
                }
                // if (link == '/about') {
                // } else if (link == '/partners') {
                //     this.$router.push('/partners');
                //     this.$parent.$parent.$refs.topProgress.start();
                // } else if (link == '/vacancy') {
                //     this.$router.push('/vacancy');
                //     this.$parent.$parent.$refs.topProgress.start();
                // } else if (link == '/sales') {
                //     window.open(
                //         'https://sales.bazis.kz',
                //         '_blank' // <- This is what makes it open in a new window.
                //     );
                // } else if (link == '/portal') {
                //     window.open(
                //         'https://portal.bazis.kz',
                //         '_blank' // <- This is what makes it open in a new window.
                //     );
                // }
                if (this.currentIndex == index) {
                    this.currentIndex = null;
                } else {
                    this.currentIndex = index
                }
                // console.log(index)
            },
            setCurrentCity(city) {
                this.$store.commit('CurrentCity', city);
                localStorage.setItem('regionCity', city);
                this.filterRegion(city);
                this.regionCity = city;
                document.location.reload(true);
            },
            filterRegion(city) {
                var data = this.setup.regions_name;
                var filteredItems = data.filter(item => {
                    return item.region_lat.slug === city
                })
                this.$store.commit('CurrentCityArr', filteredItems);
            },
            startLoader() {
                this.$parent.$parent.$refs.topProgress.start();
            }
        },
        created() {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/nav-main/nav-main-respond.scss';
</style>